import { reactive, onMounted, onBeforeUnmount } from '@vue/composition-api'
// import './auto-clean/'
import handleValueOrFunction from '@iez/lib/handle-value-or-function/'

// To use in setup()
/*
  {
    side?: {
      subtitle: String,
      title: String
    } | String,
    action?: {
      isLoading: Boolean,
      onClick: Function,
      label: String
    }
  }
*/
export const state = reactive({
  bottomAction: null
})

export default () => {
  const methods = {
    clearInput: () => {
      if (state.bottomAction?.textInput.model) {
        state.bottomAction.textInput.model = ``
      }
    },
    set: bottomAction => {
      onMounted(
        () => {
          handleValueOrFunction({
            valueOrFunction: bottomAction,
            callback: bottomAction => {
              if (bottomAction) {
                state.bottomAction = bottomAction
              } else {
                state.bottomAction = null
              }
            }
          })
        }
      )

      onBeforeUnmount(
        () => {
          state.bottomAction = null
        }
      )

      return state
    }
  }

  return {
    state,
    ...methods
  }
}
